import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Refresh from '@material-ui/icons/Refresh';
import classNames from 'classnames';
import Alert from '../alert';
import BlockLists from '../blockLists';
import {config, settings} from '../../config/config';
import axios from 'axios';

const styles = theme => ({
  icon: {
    marginRight: theme.spacing.unit * 2
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
      width: 1100,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  root: {
    flexGrow: 1
  },
  typography: {
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    backgroundColor: theme.palette.background.paper
  },
  paper: {
    padding: theme.spacing.unit * 2,
    color: theme.palette.text.secondary,
    boxShadow: "0px 0px 0px ",
    border: "1px solid #dedede"
  },
  paperDescription: {
    margin: "10px",
    padding: theme.spacing.unit * 2,
    color: theme.palette.text.secondary,
    boxShadow: "0px 0px 0px "
  }
});

class Index extends Component {

  constructor() {
    super();
    this.loadMore = this.loadMore.bind(this);
    this.alertHandleClose = this.alertHandleClose.bind(this);
  }

  state = {
    offset: "",
    onlyMine : false,
    isLoading: false,
    isAlertOpen: false,
    alertErrorMessage: "",
    results: {
      data: []
    },
    LoadMore: "更に読み込む"
  };

  componentDidMount() {
    this.loadMore();
  }

  async loadMore(isRevised = false, onlyMine = false) {
    if (this.state.isLoading) {
      return;
    }
    try {
      this.setState({isLoading: true, isLast: false});
      let parameter = new URLSearchParams();
      if(isRevised){
        parameter.append("offset", 0);
        parameter.append("onlyMine", onlyMine);
      }else{
        parameter.append("offset", this.state.offset);
        parameter.append("onlyMine", this.state.onlyMine);
      }
      const response = await axios.post(settings.url + "/load", parameter, config);
      if (response) {
        if (response.data.mes !== "ok") {
          throw response.data.reason;
        } else {
          let LoadMore = "更に読み込む";
          const isLast = response.data.data.nextOffset === "-1" ? true : false;
          let val = Object.values(response.data.data.result);
          if( (isRevised && onlyMine) || this.state.onlyMine){
            let newVal = [];
            for(let i = 1; i < val.length + 1; i++){
              newVal.push(val[val.length - i]);
            }
            val = newVal;
          }
          Array.prototype.push.apply(this.state.results.data,val);
          if (isLast) {LoadMore = "すべて読み込みました"}
          this.setState({
            isLoading: isLast,
            results: {
              data: this.state.results.data
            },
            offset: response.data.data.nextOffset,
            LoadMore: LoadMore
          });
        }
      }
    } catch (e) {
      this.setState({isLoading: false, isAlertOpen: true, alertErrorMessage: e});
    }
  }

  handleChangeChkbox = name => event => {
    this.setState({[name]: event.target.checked,results:{data:[]}});
    this.loadMore(true,event.target.checked);
  };

  alertHandleClose() {
    this.setState({isAlertOpen: false});
  }

  render() {
    const {classes} = this.props;
    return (<div>
      <Grid container={true}>
        <Grid item={true} xs={12}>
          <Paper className={classes.paper}>
            <Typography component="h5" variant="h5" className={classes.typography}>
              作成済みブロックリストをダウンロード
            </Typography>
            <form className={classes.container} noValidate="noValidate" autoComplete="off">
              <FormControlLabel style={{
                  userSelect: "none"
                }} control={<Switch
                checked = {
                  this.state.onlyMine
                }
                onChange = {
                  this.handleChangeChkbox('onlyMine')
                }
                value = "onlyMine"
                />} label="自分の作成したCSVのみ表示"/>
            </form>
            <BlockLists results={this.state.results}/>
            <Button variant="contained" size="large" color="secondary" fullWidth={true} className={classes.button} onClick={this.loadMore.bind(this,false)} disabled={this.state.isLoading} style={{margin:"20px 0"}}>
              <Refresh className={classNames(classes.leftIcon, classes.iconSmall)} style={{
                  marginRight: "5px"
                }}/> {this.state.LoadMore}
            </Button>
          </Paper>
        </Grid>
      </Grid>
      <Alert open={this.state.isAlertOpen} handleClose={this.alertHandleClose} errorMessage={this.state.alertErrorMessage}/>
    </div>)
  }
}

Index.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Index);
